import React from 'react';
import { Modal, Input, Form, Select, Icon, DatePicker, Empty, Table } from 'antd';
import dialog from '../../../common/utility/dialog';
import moment from "moment";
import { FORMAT_2DECIMALS } from "../../../common/types/regularExpresionType";
import global from '../../../common/utility/global';

const { Option } = Select;
const InputGroup = Input.Group;
const { TextArea } = Input;

class ViewModalSolicitud extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    handleCancel = () => {
        this.props.onClose();
        this.props.form.resetFields();
    }

    render() {

        const { getFieldDecorator } = this.props.form;
        getFieldDecorator('id', { initialValue: this.props.formValues.id });
        return (
            <Modal
                title={"Ver la Solicitud de Efectivo "}
                visible={this.props.visible}
                cancelText={"Cerrar"}
                okText={"Ok"}
                onCancel={this.handleCancel}
                onOk={this.handleCancel}
                style={{ top: 30 }}
            >
                <Form>
                    <div className="row">
                        <div className="col-md-6">
                            <Form.Item label={"Fecha Solicitud"}>
                                <Input
                                    placeholder="Monto Pen"
                                    autoComplete="off"
                                    onKeyPress={global.onKeyPressDecimals}
                                    readOnly
                                    value={this.props.formValues.fechaApertura}
                                />
                            </Form.Item>
                        </div>
                        <div className="col-md-6">
                            <Form.Item label="Centro Costo">
                                {getFieldDecorator("idCentroCosto", {
                                    initialValue: this.props.formValues.idCentroCosto
                                        ? { key: this.props.formValues.idCentroCosto }
                                        : undefined
                                })(
                                    <Select
                                        showSearch
                                        labelInValue
                                        placeholder={"Seleccione Centro Costo"}
                                        optionFilterProp="children"
                                        disabled
                                    >
                                        {this.props.formValues.centroCosto.map((item) => (
                                            <Option key={item.id} value={item.id}>
                                                {item.nombre}
                                            </Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>

                    </div>

                    <div className="row">
                        <div className="col-md-12">

                            <Form.Item label="Empleado">
                                <InputGroup compact>
                                    <Form.Item style={{ width: "100%" }}>
                                        {getFieldDecorator("idResponsable", {
                                            initialValue: this.props.formValues.idResponsable
                                                ? { key: this.props.formValues.idResponsable }
                                                : undefined
                                        })(

                                            <Select
                                                showSearch
                                                labelInValue
                                                placeholder={"Seleccione Responsable"}
                                                optionFilterProp="children"
                                                disabled
                                            >
                                                {this.props.formValues.empleados.map(item => (
                                                    <Option key={item.id} value={item.id}>{item.numeroDocumento} - {item.nombre}</Option>
                                                ))}

                                            </Select>

                                        )}
                                    </Form.Item>
                                </InputGroup>
                            </Form.Item>

                        </div>
                        <div className="col-md-12">
                            <Form.Item label="Motivo">
                                <TextArea
                                    placeholder="Motivo"
                                    autoComplete="off"
                                    rows={4}
                                    value={this.props.formValues.motivo}
                                />
                            </Form.Item>
                        </div>

                        <div className="col-md-6">
                            <Form.Item label={"Monto Solicitado "+ this.props.formValues.moneda }>

                                <Input
                                    placeholder="Monto"
                                    autoComplete="off"
                                    onKeyPress={global.onKeyPressDecimals}
                                    readOnly
                                    value={this.props.formValues.montoSolicitud.toFixed(2)}
                                />
                            </Form.Item>
                        </div>

                        <div className="col-md-12">
                            <Table
                                className={'table-producto'}
                                scroll={{ x: true }}
                                size="small"
                                style={{ overflowX: 'auto' }}
                                pagination={false}
                                dataSource={this.props.formValues.listaComprobanteDetalle}
                                rowKey={record => record.uid}
                                locale={{
                                    emptyText: <Empty
                                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                                        description='No se han agregado productos'
                                    />
                                }}
                                columns={[
                                    {
                                        title: 'Tipo Sustento',
                                        dataIndex: 'tipoSustento',
                                        key: 'tipoSustento',
                                        align: 'center',
                                        ellipsis: true
                                    },
                                    {
                                        title: 'Documento Sustento',
                                        dataIndex: 'serieCorrelativo',
                                        key: 'serieCorrelativo',
                                        ellipsis: true,
                                    },
                                    {
                                        title: 'Moneda Original',
                                        dataIndex: 'moneda',
                                        key: 'moneda',
                                        ellipsis: true
                                    },
                                    {
                                        title: 'Monto Sustentado',
                                        dataIndex: 'montoSustento',
                                        key: 'montoSustento',
                                        align: 'center',
                                        width: 90,
                                        render: (value) => (
                                            <span>{value.toFixed(2)}</span>
                                        )
                                    }
                                ]}
                            />
                        </div>
                    </div>
                </Form>
            </Modal>
        );
    }
}
export default Form.create()(ViewModalSolicitud)